
import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { AppContainer } from 'react-hot-loader'
import * as serviceWorker from './serviceWorker'
import { store } from './store'
import { routes } from './routes'
import { ThemeProvider } from '@mui/material/styles';
import { MaterialTheme } from './styles/Theme'
import * as Sentry from "@sentry/react";
// New Theme
import { GlobalStyleSheet } from './styles/GlobalStyles'

/**
 * Turns on hot reloading. This is if hot reloading is available. We turn this off for Cypress testing used by SEIT.
 */
const { hot } = module

if (hot) hot.accept();

// App Starter
const AppStarter = () => {

  return (
    <AppContainer>
      <Provider store={store}>
        <ThemeProvider theme={MaterialTheme}>
          <>
            <GlobalStyleSheet />
            {routes}
          </>
        </ThemeProvider>
      </Provider>
    </AppContainer>
  )
}

// SENTRY
Sentry.init({
  dsn: "https://9d60ae1c33bd8d7a571f46772cbe8823@o4505780915077120.ingest.sentry.io/4505780919599104",
  integrations: [
    new Sentry.BrowserTracing({
      // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
      tracePropagationTargets: ["localhost", "https://api.capturecollab.com", "https://app.capturecollab.com", "https://stagingapp.capturecollab.com", "https://stagingapi.capturecollab.com"],
    }),
    new Sentry.Replay(),
  ],
  // Performance Monitoring
  tracesSampleRate: 1.0, // Capture 100% of the transactions, reduce in production!
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

// Ready. Set. Go
ReactDOM.render(<AppStarter />, document.getElementById('root'))


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()